// extracted by mini-css-extract-plugin
export var divider = "_v2-0";